import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { PageLoader } from "@/components/PageLoader";
import { authService } from "@/lib/services";
import { resolveAuthenticatedAppPath } from "@/lib/pwa-launch";

export const Route = createFileRoute("/launch")({
  component: PwaLaunchPage,
  head: () => ({
    meta: [{ title: "Abriendo…" }, { name: "robots", content: "noindex, nofollow" }],
  }),
});

function PwaLaunchPage() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const user = await authService.getCurrentUser();
      if (cancelled) return;
      if (!user) {
        void navigate({ to: "/", replace: true });
        return;
      }
      void navigate({ to: resolveAuthenticatedAppPath(user.role), replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return <PageLoader variant="screen" label="Abriendo tu workspace…" />;
}
